import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from "react-router-dom";
import * as ROUTES from '../../../../../constants/routes';
import styled from 'styled-components';
import * as MDICONS from '@material-ui/icons';
import ReactModal from 'react-modal';
import { get } from 'lodash'
import AllFloorsStats from './AllFloorsStats';
import SingleFloorStats from './SingleFloorStats';

class StatsFloorCard extends Component {
    constructor(props) {
        super(props)

        this.state = {
            activityMode: false,
            selectedFloorMap: {
                floorid: '',
                name: '',
                dateCreated: {
                    _seconds: 0,
                    _nanoseconds: 0,
                },
            }
        }
    }

    /// README: Choose part to open
    chooseFloor = (selectedFloorMap) => {
        this.setState({
            selectedFloorMap,
        })
    }

    /// README: Toggle activity mode to show a different variant of graph
    toggleActivityMode = () => {
        const activityMode = !this.state.activityMode;
        this.setState({
            activityMode,
        })
    }

    /// README: Compare to sort
    compare(a, b) {
        if ('dateCreated' in a && 'dateCreated' in b) {
            if (a.dateCreated && b.dateCreated) {
                if (a.dateCreated.seconds < b.dateCreated.seconds) {
                    return -1;
                }
                if (a.dateCreated.seconds > b.dateCreated.seconds) {
                    return 1;
                }
            }
        }
        return 0;
    }

    /// README: MODAL CONTROLLING
    handleOpenModal = (num) => {
        switch (num) {
            default: {
                this.setState({});
                break;
            }
        }
    }

    handleCloseModal = (num) => {
        switch (num) {
            default: {
                this.setState({});
                break;
            }
        }
    }

    componentDidMount() {
        const augemntedSegmentId = `Overall ${this.props.commonLabels.aloneAssetParts}`
        this.setState({
            selectedFloorMap: {
                floorid: `${augemntedSegmentId}`,
                name: `${augemntedSegmentId}`,
                dateCreated: {
                    _seconds: 0,
                    _nanoseconds: 0,
                },
            }
        })
    }

    render() {
        const { themeColors, alu, userData, companyData, snagDetail, modalStyles, project, commonLabels, modalInfoTextStyle } = this.props;
        const { uid, employeeid } = userData;
        const { floorsMap } = snagDetail;
        const { selectedFloorMap, activityMode } = this.state;
        const { aloneAssetParts, assetParts, assetPart, uassetParts, uassetPart } = commonLabels;

        /// augment the part map with all option
        const augemntedSegmentId = `Overall ${aloneAssetParts}`
        var augmentedFloorMap = [{
            'floorid': `${augemntedSegmentId}`,
            'name': `${augemntedSegmentId}`,
            "dateCreated": {
                "_seconds": 0,
                "_nanoseconds": 0,
            },
        }]
        Object.values(snagDetail.floorsMap).forEach((val, i) => (
            augmentedFloorMap.push(val)
        ))

        const selectedFloorName = selectedFloorMap.name;
        const selectedFloorid = selectedFloorMap.floorid;
        const typeOfGraphText = activityMode ? `View divisions in ${augemntedSegmentId === selectedFloorName ? `all the ${aloneAssetParts}` : `${selectedFloorName}`}` : `See activity in ${augemntedSegmentId === selectedFloorName ? `all the ${aloneAssetParts}` : `${selectedFloorName}`}`;

        const graphToShow = selectedFloorid === `${augemntedSegmentId}` ? <AllFloorsStats activityMode={activityMode} /> : <SingleFloorStats selectedFloorid={selectedFloorid} activityMode={activityMode} />;

        return (
            <div className="card p-2" style={{ borderRadius: '15px' }}>
                <div className="card-header bg-white p-0 mx-2">
                    <div className="row">
                        <div className="col-8">
                            <p style={{ textAlign: "start", fontWeight: "bold", fontSize: "18px" }}>{uassetPart} statistics</p>
                        </div>
                        <div className="col-4">
                            {/* DROPDOWN */}
                            <div className="dropdown show">
                                <span className="btn btn-flat btn-sm dropdown-toggle border-bottom" style={{ fontWeight: 'bold', fontSize: '14px' }} role="button" id="dropdownFloorStatsLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    {selectedFloorName.length > 35 ? `${selectedFloorName.substring(0, 35)}...` : `${selectedFloorName}`}
                                </span>
                                <div className="dropdown-menu border" style={{ maxHeight: '400px', overflow: 'auto' }} aria-labelledby="dropdownMenuLink">
                                    {augmentedFloorMap.sort(this.compare).map((augmentedFloorMap, i) => (
                                        <span style={{ fontSize: "12px" }} role="button" className="dropdown-item" key={i} onClick={() => { this.chooseFloor(augmentedFloorMap) }} data-toggle="tooltip" data-placement="top" title={augmentedFloorMap}>
                                            {augmentedFloorMap.name.length > 25 ? `${augmentedFloorMap.name.substring(0, 25)}...` : `${augmentedFloorMap.name}`}
                                        </span>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                    <p style={modalInfoTextStyle}>These graphs are plotted and updated as soon as changes are observed.</p>
                </div>
                <div className="card-body">
                    {/* GRAPHS */}
                    {graphToShow}
                    <button className=" text-decoration-none btn btn-link btn-sm mt-3" style={{ color: "black", textDecoration: 'underline' }} onClick={() => { this.toggleActivityMode() }}>{typeOfGraphText}</button>
                </div>
            </div>
        )
    }
}


const mapStateToProps = (state) => {
    return {
        themeColors: state.theme,
        dashboardSidebarSize: state.appControl.dashboardSidebarSize,
        alu: state.alu,
        // styles
        modalTitleStyle: state.appControl.modalTitleStyle,
        modalInfoTextStyle: state.appControl.modalInfoTextStyle,
        modalStyles: state.appControl.modalStyles,

        userData: state.firebase.profile,
        companyData: state.firestore.data.Company,
        commonLabels: state.commons,
        project: state.project,
        snagDetail: get(state.firestore.data, `Snag.${state.project.proid}`),

    }
}

export default connect(mapStateToProps)(StatsFloorCard)
